import React from 'react';

export const ViewBusiness = React.lazy(() => import('./ViewBusiness'));
export const NewBusiness = React.lazy(() => import('./NewBusiness'));
export const EditBusiness = React.lazy(() => import('./EditBusiness'));
